var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',_vm._g(_vm._b({attrs:{"current-page":_vm.CurrentPage,"page-sizes":_vm.pageSizes,"layout":_vm.layout},on:{"update:currentPage":function($event){_vm.CurrentPage=$event},"update:current-page":function($event){_vm.CurrentPage=$event}}},'el-pagination',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61af902a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/commons/ZmPageBar/index.vue
// module id = null
// module chunks = 